export const alertsSample = [
  {
    id: "1dbb8000-e803-475d-bafc-72942956b001",
    sensorId: "9dbb832c-e803-475d-bafc-72942956bf91",
    designation: "Quadro eléctrico muito quente",
    severity: "HIGH",
    type: "MAX",
    value: 45,
    active: true,
  },
  {
    id: "1dbb8000-e803-475d-bafc-72942956b002",
    sensorId: "9dbb832c-e803-475d-bafc-72942956bf92",
    designation: "Quadro eléctrico muito humido",
    severity: "HIGH",
    type: "MAX",
    value: 95,
    active: true,
  },
  {
    id: "1dbb8000-e803-475d-bafc-72942956b003",
    sensorId: "9dbb832c-e803-475d-bafc-72942956bf93",
    designation: "Caixa muito quente - verificar se está ao sol",
    severity: "HIGH",
    type: "MAX",
    value: 45,
    active: true,
  },
  {
    id: "1dbb8000-e803-475d-bafc-72942956b004",
    sensorId: "9dbb832c-e803-475d-bafc-72942956bf95",
    designation: "Temperatura da estufa muito baixa",
    severity: "MEDIUM",
    type: "MIN",
    value: 5,
    active: true,
  },
  {
    id: "1dbb8000-e803-475d-bafc-72942956b005",
    sensorId: "9dbb832c-e803-475d-bafc-72942956bf95",
    designation: "Temperatura (1) da estufa muito baixa",
    severity: "MEDIUM",
    type: "MIN",
    value: 5,
    active: false,
  },
  {
    id: "1dbb8000-e803-475d-bafc-72942956b006",
    sensorId: "9dbb832c-e803-475d-bafc-72942956bf96",
    designation: "Temperatura (2) sem leituras",
    severity: "LOW",
    type: "NULL",
    value: 5,
    active: true,
  },
]